<template>
  <nav aria-label="breadcrumb" class="breadcrumb-navbar">
    <ol class="breadcrumb">
      <li class="breadcrumb-item breadcrumb-txt">
        <!-- <router-link to="/">{{ $t("messages.home.mainPage") }}</router-link> -->
        {{ currentMainMenu }}
      </li>
      <li class="breadcrumb-item active breadcrumb-txt" aria-current="page">
        {{ currentMenu }}
      </li>
    </ol>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BreadCrumb",
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    currentMainMenu: function() {
      return this.currentLang == "th"
        ? this.appInfo.currentMainMenu.th
        : this.appInfo.currentMainMenu.en;
    },
    currentMenu: function() {
      return this.currentLang == "th"
        ? this.appInfo.currentMenu.th
        : this.appInfo.currentMenu.en;
    }
  }
};
</script>
